<div class="home-page">
  <div class="home-shell">
    <section class="home-hero" aria-label="Welcome">
      <div class="hero-copy">
        <p class="hero-lead">
          A university-community partnership for research integration,
          translation, and communication.
        </p>
        <app-searchbar></app-searchbar>
      </div>
      <div class="hero-visual">
        <img
          src="https://kx-assets.s3.amazonaws.com/2023-01/20230124_eBarns_Landing%20Page%20Header%20Graphic_JSP_v1.0.png"
          alt=""
        />
      </div>
    </section>

    <section class="home-section tools">
      <content-list [content]="iconSlides" type="icon-slider"></content-list>
    </section>

    <section class="home-section featured">
      <content-list
        [content]="featuredContent"
        [sortByDate]="isProduction"
        type="image-slider-with-descriptions"
        head="Featured Content"
      ></content-list>
    </section>

    <section class="home-section explore" aria-label="Browse content by type">
      <div class="explore-grid">
        <a href="/search?types=File" aria-label="Files" matTooltip="Files">
          <kx-icon id="explore_files" size="lg"></kx-icon>
        </a>

        <a
          href="/search?types=Image%20Collection"
          aria-label="Galleries"
          matTooltip="Galleries"
        >
          <kx-icon id="explore_photo_gallery" size="lg"></kx-icon>
        </a>

        <a href="/search?types=Link" aria-label="Links" matTooltip="Links">
          <kx-icon id="explore_links" size="lg"></kx-icon>
        </a>

        <a href="/podcast" aria-label="Podcasts" matTooltip="Podcasts">
          <kx-icon id="explore_podcasts" size="lg"></kx-icon>
        </a>

        <a
          href="/search?types=Question"
          aria-label="Questions"
          matTooltip="Questions"
        >
          <kx-icon id="explore_questions" size="lg"></kx-icon>
        </a>

        <a href="/search?types=Story" aria-label="Stories" matTooltip="Stories">
          <kx-icon id="explore_stories" size="lg"></kx-icon>
        </a>

        <a href="/search?types=Video" aria-label="Videos" matTooltip="Videos">
          <kx-icon id="explore_videos" size="lg"></kx-icon>
        </a>

        <a
          href="/search?types=Virtual%20Tour"
          aria-label="Virtual Tours"
          matTooltip="Virtual Tours"
        >
          <kx-icon id="explore_virtual_tours" size="lg"></kx-icon>
        </a>
      </div>
    </section>
  </div>
</div>
